// TODO - Update the assetTags and windowsMachineName data
export const overview_views = {
  carts: [
    {
      id: 2017,
      name: '5 North',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7164',
          capacity: 200,
          wastedCount: 1,
          percentFull: 65,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3273',
          capacity: 200,
          wastedCount: 5,
          percentFull: 55,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 26,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      error: {
        description: 'Lockbox open',
        detectedAt: '2023-10-01T12:00:00Z',
        priority: 'Low',
        attendedBy: 'John Doe',
        startAttendedAt: '2023-10-01T12:00:00Z',
        finishAttendedAt: '2023-10-01T12:00:00Z',
      },
      windowsMachineName: 'IQ-LAP47',
      assetTag: 'MS867531',
    },
    {
      id: 7755,
      name: '3B South',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1128',
          capacity: 200,
          wastedCount: 5,
          percentFull: 100,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1387',
          capacity: 200,
          wastedCount: 5,
          percentFull: 27,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 16,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      error: {
        description: 'Lockbox open',
        detectedAt: '2023-10-01T12:00:00Z',
        priority: 'High',
        attendedBy: 'Richard M',
        startAttendedAt: '2023-10-01T12:00:00Z',
      },
      windowsMachineName: 'IQ-LAP48',
      assetTag: 'MS867532',
    },
    {
      id: 6239,
      name: 'PICU',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6645',
          capacity: 200,
          wastedCount: 2,
          percentFull: 15,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '7898',
          capacity: 200,
          wastedCount: 4,
          percentFull: 47,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 51,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      error: {
        description: 'Lockbox open',
        detectedAt: '2023-10-01T12:00:00Z',
        priority: 'High',
      },
      windowsMachineName: 'IQ-LAP49',
      assetTag: 'MS867533',
    },
    {
      id: 5999,
      name: 'OR-5',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9309',
          capacity: 200,
          wastedCount: 3,
          percentFull: 19,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3230',
          capacity: 200,
          wastedCount: 3,
          percentFull: 9,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 20,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      windowsMachineName: 'IQ-LAP50',
      assetTag: 'MS867534',
    },
    {
      id: 1977,
      name: 'ER-8',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '4713',
          capacity: 200,
          wastedCount: 1,
          percentFull: 72,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3651',
          capacity: 200,
          wastedCount: 0,
          percentFull: 31,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 54,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      windowsMachineName: 'IQ-LAP51',
      assetTag: 'MS867535',
    },
    {
      id: 1167,
      name: '1 North',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '5264',
          capacity: 200,
          wastedCount: 2,
          percentFull: 39,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2921',
          capacity: 200,
          wastedCount: 3,
          percentFull: 30,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 47,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      windowsMachineName: 'IQ-LAP56',
      assetTag: 'MS867536',
    },
    {
      id: 6279,
      name: '2B South',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2143',
          capacity: 200,
          wastedCount: 5,
          percentFull: 38,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3509',
          capacity: 200,
          wastedCount: 5,
          percentFull: 28,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 50,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      windowsMachineName: 'IQ-LAP57',
      assetTag: 'MS867537',
    },
    {
      id: 3971,
      name: 'OR-2',
      location: [
        {
          id: 5,
          name: 'Manhattan - Building A',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 5,
      locationName: 'Manhattan - Building A',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '4474',
          capacity: 200,
          wastedCount: 1,
          percentFull: 1,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '7899',
          capacity: 200,
          wastedCount: 0,
          percentFull: 49,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 53,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 5,
      buildingName: 'Manhattan - Building A',
      windowsMachineName: 'IQ-LAP58',
      assetTag: 'MS867538',
    },
    {
      id: 7703,
      name: 'ER-8',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2152',
          capacity: 200,
          wastedCount: 0,
          percentFull: 96,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4409',
          capacity: 200,
          wastedCount: 1,
          percentFull: 26,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 74,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP59',
      assetTag: 'MS867539',
    },
    {
      id: 7427,
      name: '6 North',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '4717',
          capacity: 200,
          wastedCount: 5,
          percentFull: 82,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4079',
          capacity: 200,
          wastedCount: 1,
          percentFull: 73,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 6,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP60',
      assetTag: 'MS867540',
    },
    {
      id: 1520,
      name: '1B South',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3945',
          capacity: 200,
          wastedCount: 5,
          percentFull: 74,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1077',
          capacity: 200,
          wastedCount: 5,
          percentFull: 50,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 26,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP61',
      assetTag: 'MS867541',
    },
    {
      id: 8801,
      name: 'OR-1',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3747',
          capacity: 200,
          wastedCount: 3,
          percentFull: 43,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4739',
          capacity: 200,
          wastedCount: 4,
          percentFull: 90,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 26,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP62',
      assetTag: 'MS867542',
    },
    {
      id: 7693,
      name: 'ER-7',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7046',
          capacity: 200,
          wastedCount: 2,
          percentFull: 24,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8934',
          capacity: 200,
          wastedCount: 3,
          percentFull: 78,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 22,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP63',
      assetTag: 'MS867543',
    },
    {
      id: 3043,
      name: '2C West',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7852',
          capacity: 200,
          wastedCount: 1,
          percentFull: 24,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1869',
          capacity: 200,
          wastedCount: 5,
          percentFull: 88,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 6,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP64',
      assetTag: 'MS867544',
    },
    {
      id: 1201,
      name: '3D North',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7530',
          capacity: 200,
          wastedCount: 0,
          percentFull: 85,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8004',
          capacity: 200,
          wastedCount: 4,
          percentFull: 92,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 47,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP65',
      assetTag: 'MS867545',
    },
    {
      id: 3413,
      name: '4A South',
      location: [
        {
          id: 6,
          name: 'Manhattan - Building B',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 6,
      locationName: 'Manhattan - Building B',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2075',
          capacity: 200,
          wastedCount: 5,
          percentFull: 51,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1594',
          capacity: 200,
          wastedCount: 4,
          percentFull: 72,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 23,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 6,
      buildingName: 'Manhattan - Building B',
      windowsMachineName: 'IQ-LAP66',
      assetTag: 'MS867546',
    },
    {
      id: 1140,
      name: 'ER-4',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2541',
          capacity: 200,
          wastedCount: 1,
          percentFull: 90,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3382',
          capacity: 200,
          wastedCount: 4,
          percentFull: 30,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 73,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP67',
      assetTag: 'MS867547',
    },
    {
      id: 5213,
      name: 'OR-8',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1189',
          capacity: 200,
          wastedCount: 2,
          percentFull: 51,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8390',
          capacity: 200,
          wastedCount: 5,
          percentFull: 81,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 47,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP68',
      assetTag: 'MS867548',
    },
    {
      id: 2205,
      name: '3N East',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2604',
          capacity: 200,
          wastedCount: 5,
          percentFull: 55,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3594',
          capacity: 200,
          wastedCount: 1,
          percentFull: 33,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 46,
      },
      cartMode: 'Wasting',
      inUse: true,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP69',
      assetTag: 'MS867549',
    },
    {
      id: 1397,
      name: 'ER-10',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1989',
          capacity: 200,
          wastedCount: 3,
          percentFull: 31,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4284',
          capacity: 200,
          wastedCount: 3,
          percentFull: 39,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 69,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP70',
      assetTag: 'MS867550',
    },
    {
      id: 1422,
      name: 'OR-5',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3974',
          capacity: 200,
          wastedCount: 3,
          percentFull: 98,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2459',
          capacity: 200,
          wastedCount: 2,
          percentFull: 39,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 21,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP71',
      assetTag: 'MS867551',
    },
    {
      id: 9760,
      name: '4S North',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1351',
          capacity: 200,
          wastedCount: 0,
          percentFull: 30,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '6557',
          capacity: 200,
          wastedCount: 4,
          percentFull: 48,
        },
      ],
      collectionBox: {
        wastedCount: 0,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 59,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP72',
      assetTag: 'MS867552',
    },
    {
      id: 8622,
      name: '1B South',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3711',
          capacity: 200,
          wastedCount: 5,
          percentFull: 66,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '6009',
          capacity: 200,
          wastedCount: 0,
          percentFull: 0,
        },
      ],
      collectionBox: {
        wastedCount: 0,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 99,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP93',
      assetTag: 'MS867553',
    },
    {
      id: 2598,
      name: '3D East',
      location: [
        {
          id: 7,
          name: 'Manhattan - Building C',
          description: '',
          parentId: 2,
          locationType: 'building',
        },
      ],
      locationId: 7,
      locationName: 'Manhattan - Building C',
      organizationName: 'General Hospital HQ - Manhattan',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '4615',
          capacity: 200,
          wastedCount: 2,
          percentFull: 76,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9534',
          capacity: 200,
          wastedCount: 3,
          percentFull: 3,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 77,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 7,
      buildingName: 'Manhattan - Building C',
      windowsMachineName: 'IQ-LAP94',
      assetTag: 'MS867554',
    },
    {
      id: 8618,
      name: 'OR-11',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6031',
          capacity: 200,
          wastedCount: 4,
          percentFull: 2,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4020',
          capacity: 200,
          wastedCount: 5,
          percentFull: 75,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 40,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP95',
      assetTag: 'MS867555',
    },
    {
      id: 1415,
      name: 'ER-2',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9353',
          capacity: 200,
          wastedCount: 5,
          percentFull: 43,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1484',
          capacity: 200,
          wastedCount: 0,
          percentFull: 81,
        },
      ],
      collectionBox: {
        wastedCount: 0,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 91,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP96',
      assetTag: 'MS867556',
    },
    {
      id: 9479,
      name: 'PICU-A',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9947',
          capacity: 200,
          wastedCount: 2,
          percentFull: 62,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '5567',
          capacity: 200,
          wastedCount: 0,
          percentFull: 5,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 10,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP97',
      assetTag: 'MS867557',
    },
    {
      id: 8906,
      name: '2S West',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6195',
          capacity: 200,
          wastedCount: 1,
          percentFull: 88,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '5076',
          capacity: 200,
          wastedCount: 5,
          percentFull: 38,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 46,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP98',
      assetTag: 'MS867558',
    },
    {
      id: 9970,
      name: '4H North',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7561',
          capacity: 200,
          wastedCount: 3,
          percentFull: 99,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2560',
          capacity: 200,
          wastedCount: 0,
          percentFull: 89,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 80,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP99',
      assetTag: 'MS867559',
    },
    {
      id: 6192,
      name: '2B East',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3762',
          capacity: 200,
          wastedCount: 2,
          percentFull: 51,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4171',
          capacity: 200,
          wastedCount: 0,
          percentFull: 20,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 8,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP100',
      assetTag: 'MS867560',
    },
    {
      id: 7761,
      name: 'ER-6',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2690',
          capacity: 200,
          wastedCount: 0,
          percentFull: 83,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '5150',
          capacity: 200,
          wastedCount: 5,
          percentFull: 85,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 23,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP101',
      assetTag: 'MS867561',
    },
    {
      id: 3838,
      name: 'OR-1',
      location: [
        {
          id: 8,
          name: 'Brooklyn - Building A',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 8,
      locationName: 'Brooklyn - Building A',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7200',
          capacity: 200,
          wastedCount: 3,
          percentFull: 32,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1638',
          capacity: 200,
          wastedCount: 3,
          percentFull: 89,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 33,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 8,
      buildingName: 'Brooklyn - Building A',
      windowsMachineName: 'IQ-LAP102',
      assetTag: 'MS867562',
    },
    {
      id: 2876,
      name: '2B South',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '8412',
          capacity: 200,
          wastedCount: 4,
          percentFull: 16,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '7691',
          capacity: 200,
          wastedCount: 3,
          percentFull: 33,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 58,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP103',
      assetTag: 'MS867563',
    },
    {
      id: 3393,
      name: '3B North',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7976',
          capacity: 200,
          wastedCount: 1,
          percentFull: 41,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8951',
          capacity: 200,
          wastedCount: 4,
          percentFull: 63,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 51,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP104',
      assetTag: 'MS867564',
    },
    {
      id: 8870,
      name: '4B West',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '8582',
          capacity: 200,
          wastedCount: 1,
          percentFull: 91,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1963',
          capacity: 200,
          wastedCount: 5,
          percentFull: 71,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 54,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP105',
      assetTag: 'MS867565',
    },
    {
      id: 2668,
      name: '3B South',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2436',
          capacity: 200,
          wastedCount: 5,
          percentFull: 27,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '5525',
          capacity: 200,
          wastedCount: 5,
          percentFull: 93,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 36,
      },
      cartMode: 'Wasting',
      inUse: true,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP72',
      assetTag: 'MS867552',
    },
    {
      id: 9027,
      name: '2B North',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3705',
          capacity: 200,
          wastedCount: 1,
          percentFull: 57,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9759',
          capacity: 200,
          wastedCount: 5,
          percentFull: 47,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 40,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP106',
      assetTag: 'MS867566',
    },
    {
      id: 9814,
      name: '2B West',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '5093',
          capacity: 200,
          wastedCount: 2,
          percentFull: 89,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '7604',
          capacity: 200,
          wastedCount: 3,
          percentFull: 89,
        },
      ],
      collectionBox: {
        wastedCount: 0,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 82,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP107',
      assetTag: 'MS867567',
    },
    {
      id: 5813,
      name: '2B East',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3013',
          capacity: 200,
          wastedCount: 4,
          percentFull: 56,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4643',
          capacity: 200,
          wastedCount: 2,
          percentFull: 52,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 49,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP108',
      assetTag: 'MS867568',
    },
    {
      id: 5366,
      name: '2B South',
      location: [
        {
          id: 9,
          name: 'Brooklyn - Building B',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 9,
      locationName: 'Brooklyn - Building B',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2193',
          capacity: 200,
          wastedCount: 2,
          percentFull: 47,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1205',
          capacity: 200,
          wastedCount: 0,
          percentFull: 49,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 1,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 9,
      buildingName: 'Brooklyn - Building B',
      windowsMachineName: 'IQ-LAP109',
      assetTag: 'MS867569',
    },
    {
      id: 2162,
      name: '2C North',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9236',
          capacity: 200,
          wastedCount: 4,
          percentFull: 93,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2492',
          capacity: 200,
          wastedCount: 4,
          percentFull: 86,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 79,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP110',
      assetTag: 'MS867570',
    },
    {
      id: 8051,
      name: '2C South',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6623',
          capacity: 200,
          wastedCount: 2,
          percentFull: 53,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '6842',
          capacity: 200,
          wastedCount: 1,
          percentFull: 63,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 25,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP111',
      assetTag: 'MS867571',
    },
    {
      id: 4289,
      name: '2C East',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7601',
          capacity: 200,
          wastedCount: 1,
          percentFull: 11,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '7814',
          capacity: 200,
          wastedCount: 5,
          percentFull: 74,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 61,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP112',
      assetTag: 'MS867572',
    },
    {
      id: 9884,
      name: '2C West',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3699',
          capacity: 200,
          wastedCount: 1,
          percentFull: 89,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1339',
          capacity: 200,
          wastedCount: 4,
          percentFull: 61,
        },
      ],
      collectionBox: {
        wastedCount: 0,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 29,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP113',
      assetTag: 'MS867573',
    },
    {
      id: 1290,
      name: '2C South',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3185',
          capacity: 200,
          wastedCount: 5,
          percentFull: 45,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2807',
          capacity: 200,
          wastedCount: 4,
          percentFull: 50,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 84,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP114',
      assetTag: 'MS867574',
    },
    {
      id: 6899,
      name: '2C East',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7789',
          capacity: 200,
          wastedCount: 0,
          percentFull: 90,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4005',
          capacity: 200,
          wastedCount: 4,
          percentFull: 2,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 17,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP115',
      assetTag: 'MS867575',
    },
    {
      id: 3199,
      name: '2C West',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3389',
          capacity: 200,
          wastedCount: 4,
          percentFull: 25,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2751',
          capacity: 200,
          wastedCount: 0,
          percentFull: 84,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 24,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP116',
      assetTag: 'MS867576',
    },
    {
      id: 8749,
      name: '2C North',
      location: [
        {
          id: 10,
          name: 'Brooklyn - Building C',
          description: '',
          parentId: 3,
          locationType: 'building',
        },
      ],
      locationId: 10,
      locationName: 'Brooklyn - Building C',
      organizationName: 'General Hospital HQ - Brooklyn',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7109',
          capacity: 200,
          wastedCount: 3,
          percentFull: 30,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '3705',
          capacity: 200,
          wastedCount: 1,
          percentFull: 39,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 5,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 10,
      buildingName: 'Brooklyn - Building C',
      windowsMachineName: 'IQ-LAP117',
      assetTag: 'MS867577',
    },
    {
      id: 1013,
      name: 'OR-2',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6972',
          capacity: 200,
          wastedCount: 4,
          percentFull: 27,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9459',
          capacity: 200,
          wastedCount: 1,
          percentFull: 46,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 70,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP118',
      assetTag: 'MS867578',
    },
    {
      id: 3191,
      name: 'OR-3',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2084',
          capacity: 200,
          wastedCount: 4,
          percentFull: 46,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1657',
          capacity: 200,
          wastedCount: 3,
          percentFull: 52,
        },
      ],
      collectionBox: {
        wastedCount: 0,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 40,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP119',
      assetTag: 'MS867579',
    },
    {
      id: 5691,
      name: 'OR-4',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1042',
          capacity: 200,
          wastedCount: 0,
          percentFull: 50,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4497',
          capacity: 200,
          wastedCount: 3,
          percentFull: 17,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 27,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP120',
      assetTag: 'MS867580',
    },
    {
      id: 3268,
      name: 'ER-1',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2158',
          capacity: 200,
          wastedCount: 1,
          percentFull: 46,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4798',
          capacity: 200,
          wastedCount: 0,
          percentFull: 85,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 91,
      },
      cartMode: 'Wasting',
      inUse: true,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP121',
      assetTag: 'MS867581', 
    },
    {
      id: 5712,
      name: 'OR-5',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1259',
          capacity: 200,
          wastedCount: 0,
          percentFull: 100,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4497',
          capacity: 200,
          wastedCount: 1,
          percentFull: 17,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 85,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP73',
      assetTag: 'MS867553',
    },
    {
      id: 7323,
      name: '1A North',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1795',
          capacity: 200,
          wastedCount: 0,
          percentFull: 31,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4403',
          capacity: 200,
          wastedCount: 4,
          percentFull: 85,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 33,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP74',
      assetTag: 'MS867554',
    },
    {
      id: 2741,
      name: '1A South',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '8559',
          capacity: 200,
          wastedCount: 4,
          percentFull: 93,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '4053',
          capacity: 200,
          wastedCount: 1,
          percentFull: 74,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 32,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP75',
      assetTag: 'MS867555',
    },
    {
      id: 4686,
      name: '1A East',
      location: [
        {
          id: 11,
          name: 'Bronx - Building A',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 11,
      locationName: 'Bronx - Building A',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '6072',
          capacity: 200,
          wastedCount: 1,
          percentFull: 18,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9686',
          capacity: 200,
          wastedCount: 1,
          percentFull: 49,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 12,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 11,
      buildingName: 'Bronx - Building A',
      windowsMachineName: 'IQ-LAP76',
      assetTag: 'MS867556',
    },
    {
      id: 4856,
      name: '1B West',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9750',
          capacity: 200,
          wastedCount: 0,
          percentFull: 65,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2223',
          capacity: 200,
          wastedCount: 5,
          percentFull: 21,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 70,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP77',
      assetTag: 'MS867557',
    },
    {
      id: 4254,
      name: '1B East',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2801',
          capacity: 200,
          wastedCount: 1,
          percentFull: 41,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '5805',
          capacity: 200,
          wastedCount: 1,
          percentFull: 68,
        },
      ],
      collectionBox: {
        wastedCount: 3,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 90,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP78',
      assetTag: 'MS867558',
    },
    {
      id: 8660,
      name: '7B South',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7069',
          capacity: 200,
          wastedCount: 1,
          percentFull: 31,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9062',
          capacity: 200,
          wastedCount: 3,
          percentFull: 25,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 57,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP79',
      assetTag: 'MS867559',
    },
    {
      id: 2055,
      name: '7B North',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3510',
          capacity: 200,
          wastedCount: 2,
          percentFull: 72,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8984',
          capacity: 200,
          wastedCount: 2,
          percentFull: 18,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 7,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP80',
      assetTag: 'MS867560',
    },
    {
      id: 2242,
      name: '7B East',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '8822',
          capacity: 200,
          wastedCount: 3,
          percentFull: 12,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1202',
          capacity: 200,
          wastedCount: 5,
          percentFull: 12,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 92,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP81',
      assetTag: 'MS867561',
    },
    {
      id: 9322,
      name: '7B West',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '7335',
          capacity: 200,
          wastedCount: 1,
          percentFull: 21,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9079',
          capacity: 200,
          wastedCount: 1,
          percentFull: 38,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 4,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP82',
      assetTag: 'MS867562',
    },
    {
      id: 9470,
      name: '7B North',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3177',
          capacity: 200,
          wastedCount: 0,
          percentFull: 61,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8928',
          capacity: 200,
          wastedCount: 2,
          percentFull: 100,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 56,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP83',
      assetTag: 'MS867563',
    },
    {
      id: 4932,
      name: '7B South',
      location: [
        {
          id: 12,
          name: 'Bronx - Building B',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 12,
      locationName: 'Bronx - Building B',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '4033',
          capacity: 200,
          wastedCount: 2,
          percentFull: 80,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8770',
          capacity: 200,
          wastedCount: 3,
          percentFull: 99,
        },
      ],
      collectionBox: {
        wastedCount: 0,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 96,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 12,
      buildingName: 'Bronx - Building B',
      windowsMachineName: 'IQ-LAP84',
      assetTag: 'MS867564',
    },
    {
      id: 2898,
      name: '5C North',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3140',
          capacity: 200,
          wastedCount: 3,
          percentFull: 84,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '6906',
          capacity: 200,
          wastedCount: 1,
          percentFull: 24,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 47,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP85',
      assetTag: 'MS867565',
    },
    {
      id: 2597,
      name: '5C South',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '2348',
          capacity: 200,
          wastedCount: 0,
          percentFull: 63,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '5695',
          capacity: 200,
          wastedCount: 2,
          percentFull: 84,
        },
      ],
      collectionBox: {
        wastedCount: 2,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 80,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP86',
      assetTag: 'MS867566',
    },
    {
      id: 1076,
      name: '5C East',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '3947',
          capacity: 200,
          wastedCount: 4,
          percentFull: 47,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8371',
          capacity: 200,
          wastedCount: 0,
          percentFull: 50,
        },
      ],
      collectionBox: {
        wastedCount: 1,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 81,
      },
      cartMode: 'Wasting',
      inUse: true,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP87',
      assetTag: 'MS867567',
    },
    {
      id: 6974,
      name: '5C West',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '8362',
          capacity: 200,
          wastedCount: 5,
          percentFull: 89,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '1763',
          capacity: 200,
          wastedCount: 3,
          percentFull: 90,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 24,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP88',
      assetTag: 'MS867568',
    },
    {
      id: 6784,
      name: '5C South',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '5203',
          capacity: 200,
          wastedCount: 3,
          percentFull: 82,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '8452',
          capacity: 200,
          wastedCount: 2,
          percentFull: 46,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 37,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP89',
      assetTag: 'MS867569',
    },
    {
      id: 4302,
      name: '5E East',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9122',
          capacity: 200,
          wastedCount: 2,
          percentFull: 76,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9938',
          capacity: 200,
          wastedCount: 1,
          percentFull: 6,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 72,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP90',
      assetTag: 'MS867570',
    },
    {
      id: 4098,
      name: '5E West',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '9450',
          capacity: 200,
          wastedCount: 1,
          percentFull: 50,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '9600',
          capacity: 200,
          wastedCount: 0,
          percentFull: 47,
        },
      ],
      collectionBox: {
        wastedCount: 4,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 98,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP91',
      assetTag: 'MS867571',
    },
    {
      id: 5738,
      name: '5E South',
      location: [
        {
          id: 13,
          name: 'Bronx - Building C',
          description: '',
          parentId: 4,
          locationType: 'building',
        },
      ],
      locationId: 13,
      locationName: 'Bronx - Building C',
      organizationName: 'General Hospital HQ - Bronx',
      collectionBins: [
        {
          containerTypeName: 'Hazardous Bin',
          serialNumber: '1284',
          capacity: 200,
          wastedCount: 0,
          percentFull: 6,
        },
        {
          containerTypeName: 'Non-Hazardous Bin',
          serialNumber: '2059',
          capacity: 200,
          wastedCount: 3,
          percentFull: 93,
        },
      ],
      collectionBox: {
        wastedCount: 5,
        containerTypeName: 'Collection Box',
        capacity: 10,
        percentFull: 91,
      },
      cartMode: 'Wasting',
      inUse: false,
      statusId: 1,
      buildingId: 13,
      buildingName: 'Bronx - Building C',
      windowsMachineName: 'IQ-LAP92',
      assetTag: 'MS867572',
    },
  ],
};
